module.exports = __webpack_public_path__ + "static/img/charge.dbef1448.png";